export async function fetchFromAPI(path, options = {}) {
    const defaultOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    }

    const gneUser = window.GNE?.user
    if (gneUser?.accountNumber) {
        defaultOptions.headers['X-GNE-Customer-ID'] = gneUser.accountNumber;
    }

    if (gneUser?.id) {
      defaultOptions.headers['X-GNE-NOP-ID'] = gneUser.id;
    }

    const resolvedOptions = merge(defaultOptions, options)
    const response = await fetch(`${process.env.REACT_APP_WEB_API_ROOT}${path}`, resolvedOptions)

    if (response.ok) {
        const data = await response.json()
        return { data }     
    } else {
        const error = await response.text()
        console.error(`The fetch request resulted in an error with the following message: "${error}"`)
        return { error, response }
    }
}

export function merge(target, source, {isMutatingOk = false, isStrictlySafe = false} = {}) {
    /* Returns a deep merge of source into target.
          Does not mutate target unless isMutatingOk = true. */
    target = isMutatingOk ? target : clone(target, isStrictlySafe);
    for (const [key, val] of Object.entries(source)) {
      if (val !== null && typeof val === `object`) {
        if (target[key] === undefined) {
          target[key] = new val.__proto__.constructor();
        }
        /* even where isMutatingOk = false, recursive calls only work on clones, so they can always
              safely mutate --- saves unnecessary cloning */
        target[key] = merge(target[key], val, {isMutatingOk: true, isStrictlySafe}); 
      } else {
        target[key] = val;
      }
    }
    return target;
}

export function clone(obj, isStrictlySafe = false) {
    /* Clones an object. First attempt is safe. If it errors (e.g. from a circular reference),
          'isStrictlySafe' determines if error is thrown or an unsafe clone is returned. */
    try {
      return JSON.parse(JSON.stringify(obj));
    } catch(err) {
      if (isStrictlySafe) { throw new Error(err) }
      console.warn(`Unsafe clone of object`, obj);
      return {...obj};
    }
}

export function formatCurrency(value) {
    if (value % 1 === 0) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minumumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value);
    }
  
   return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
    }).format(value);
}